import React, { useEffect } from "react"; 
import Popup from '../Component/Popup'
import HomeSlider from '../Component/HomeSlider'
import TopperXII from '../Component/TopperXII'
import TopperX from '../Component/TopperX'
import Events from '../Component/Events'
import Birthday from '../Component/Birthday'
import News from '../Component/News'
import Calender from '../Component/Calender'
import Campuscare from '../Component/Campuscare'
import OnlineRegistration from '../Component/OnlineRegistration'
import Gallery from '../Component/Gallery'
import Message from '../Component/Message'
import { Link } from 'react-router-dom'
import ClassTabs from '../Component/ClassTabs'
import FacebookPagePlugin from '../Component/Facebook' 
import YouTubeWidget from '../Component/YouTubewidget'
import Header from '../Component/Header'; 
import Footer from '../Component/Footer'; 
import LazyLoad from 'react-lazyload'
const Home = () => {
  useEffect(() => {
    document.title = 'Home  -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>
      <Header />
      <Campuscare />
      <Popup />
      <OnlineRegistration />
      <HomeSlider />
      <div className="aboutmidsec padded-sec">
        <div className='button'>
          <Link to="/Criteria" target="_blank">
            <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/admission.png" alt="mercy memorial School" className='img-fluid' /></LazyLoad>
            <p>Admission</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="SchoolCalendar" target='_blank'>
            <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/Calendar.png" alt="mercy memorial School" className='img-fluid' /></LazyLoad>
            <p> Calendar</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/Alumni">
            <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/alumni.png" alt="mercy memorial School" className='img-fluid' /></LazyLoad>
            <p>Alumni </p></Link>
        </div>
        <div className='phone'>
        <Link to="tel:+91-512-4000406">
            <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/phone.gif" alt="Mercy Memorial School, Kanpur" /></LazyLoad>
            </Link>
        </div>
        <div className='button'>
          <Link to="/Curriculum">
            <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/curriculam.png" alt="mercy memorial School" className='img-fluid' /></LazyLoad>
            <p>Curriculum</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/Academics">
            <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/academic.png" alt="mercy memorial School" className='img-fluid' /></LazyLoad>
            <p>Academics</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="https://mercymemorial.campussoft.net/" target="_blank">
            <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/erp-login.png" alt="mercy memorial School" className='img-fluid' /></LazyLoad>
            <p>ERP Login</p>
          </Link>
        </div>
      </div>
      <div className="aboutsec">
        <div className='about-animation'>
          <div className='anim-sld1'></div>
          <div className='anim-sld2'></div>
          <div className='anim-sld3'></div>
          <div className='anim-sld4'></div>
          <div className='anim-sld5'></div>
          <div className='anim-sld6'></div>
          <div className='anim-sld7'></div>
          <div className='anim-sld8'></div>
          <div className='anim-sld9'></div>
          <div className='anim-sld10'></div>
          <div className='anim-sld11'></div>
          <div className='anim-sld12'></div>
        </div>
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-lg-6 about-bg">
              <div className="about-news">
                <div className='title'>
                  <h2>Mercy memorial School</h2>
                </div>
                <p><b>Responding to a decade's pressing demand for an English-medium institution in Kidwai Nagar, Kanpur, Mrs. Sophie Shukla, under the aegis of the Huddard Junior High School Society, established this institution in memory of her worthy sister, Ms. Mercy Roberts, in 1983.</b></p> 
                <p> In its first month, the school admitted around <b>500</b> children. With the rising demand for admissions, the management increased the number of sections, bringing the total to<b> 3,600</b> students today.</p> 
                <p> The management succeeded in getting the school affiliated with the Council for the Indian School Certificate Examinations in <b>January 1990</b>.</p>
                <Link to="/AboutUs"><button className='button'>Read More <i className="bi bi-arrow-right"></i></button></Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-img">
                <div className='abt_abs abs-img1'><LazyLoad><img src='https://webapi.entab.info/api/image/MMSKN/public/Images/about1.png' alt="Mercy Memorial School, Kanpur" /></LazyLoad></div>
                <div className='abt_abs abs-img2'><LazyLoad><img src='https://webapi.entab.info/api/image/MMSKN/public/Images/about2.png' alt="Mercy Memorial School, Kanpur" /></LazyLoad></div>
                <div className='center-img'><LazyLoad><img src='https://webapi.entab.info/api/image/MMSKN/public/Images/aboutimg.png' className='abs-img3' alt="Mercy Memorial School, Kanpur" /></LazyLoad></div>
                <div className='abt_abs abs-img4'><LazyLoad><img src='https://webapi.entab.info/api/image/MMSKN/public/Images/about3.png' alt="Mercy Memorial School, Kanpur" /></LazyLoad></div>
                <div className='abt_abs abs-img5'><LazyLoad><img src='https://webapi.entab.info/api/image/MMSKN/public/Images/about4.png' alt="Mercy Memorial School, Kanpur" /></LazyLoad></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='classSection'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <ClassTabs />

            </div>

          </div>
        </div>
      </div>
      <div className='calender'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='title'>
                <h2>Academic Calender </h2>
              </div>
              <Calender />

            </div>

          </div>
        </div>
      </div>
      <div className="event">
        <div className="container fulwidth">
          <div className="row">
            <div className="col-lg-12 section-title">
              <div className='title'>
                <h2>FROM THE DESK OF</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Message />
            </div>
          </div>
        </div>
      </div>
      <div className='events padded-sec'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xl-6 col-md-12'>
              <div className='title'>
                <h2>Events in <span>the school</span></h2>
              </div>
              <Events />
            </div>
            <div className='col-xl-6 col-md-12'>
              <div className='title'>
                <h2>latest news/<span>announcement</span></h2>
              </div>
              <News />
            </div>
          </div>
        </div>
      </div>
      <div className="topper_bg padded-sec">
        <div className="container-fluid section-title">
          <div className='row'>
            <div className='col-xl-8'>
              <div className='row'>

              <div className='col-md-12'>
              <div className='title'>
                  <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/stars.gif" className='img-fluid m-auto d-block' /></LazyLoad>
                <h2>our shining <span>stars</span></h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className='topper-block'>
                <div className='title'>
                  <h4>ISC Toppers</h4>

                  <div className='arrrow-btn'>
                    {/* <Link to="/">
                    <i className="bi bi-chevron-right"></i></Link>*/}
                  </div>
                </div>
                <TopperXII />
              </div>
              <button className='button m-auto '><Link to="/ISCToppers">Read More <i className="bi bi-arrow-right"></i></Link></button>
            </div>

            <div className="col-lg-6">
              <div className='topper-block'>
                <div className='title'>
                  <h4>ICSE Toppers</h4>
                  <div className='arrrow-btn'>
                    {/* <Link to="/">
                    <i className="bi bi-chevron-right"></i>
                  </Link> */}
                  </div>
                </div>
                <TopperX />
              </div>
              <button className='button m-auto '><Link to="/ICSEToppers">Read More <i className="bi bi-arrow-right"></i></Link></button>
            </div>
              </div>
            </div>
            <div className='col-xl-4'>
              
            <div className='col-md-12'>
              <div className='title'>
              <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/birthday.gif" className='img-fluid m-auto d-block' /></LazyLoad>
                <h2>today’s  <span>birthday</span></h2>
              </div>
            </div>
            <div className="col-lg-12">
              <div className='topper-block'>
                <div className='title'>
                  <h2> </h2>
                </div>
                <Birthday />
              </div>
              
            </div>
 
            </div>
          </div>
           
        </div>
      </div> 

      <div className="homegallery padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className='col-md-12 section-title'>
              <div className='title'>
                <h2>Activities in Images</h2>
              </div>
            </div>
            <div className="col-lg-12">

              <Gallery />
              {/* <button className='button'><Link to="/Gallery">Read More</Link></button> */}
            </div>
          </div>
        </div>
      </div>
      <div className='facebook'>
        <div className='container'>
          <div className='row'>
             <div className='col-md-4'>
              
            </div>
            <div className='col-md-6'>
              <FacebookPagePlugin />
            </div>
           
            <div className='col-md-2'></div>
            {   /*  <div className='col-md-5'>
              <YouTubeWidget />
            </div> */}
          </div>
        </div>
      </div>
      <Footer/>
    </>
  )
}
export default Home